var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 4C23 5.65685 21.6569 7 20 7C18.3431 7 17 5.65685 17 4C17 2.34315 18.3431 1 20 1C21.6569 1 23 2.34315 23 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5C6.89543 5 6 5.89543 6 7V11H5C4.44772 11 4 10.5523 4 10V8.5C4 7.67157 3.32843 7 2.5 7C1.67157 7 1 7.67157 1 8.5V10C1 12.2091 2.79086 14 5 14H6V17.2088C4.59532 17.2703 3.20532 17.6768 1.96129 18.4232C1.36491 18.7811 1 19.4256 1 20.121V22C1 22.5523 1.44772 23 2 23H20C20.5523 23 21 22.5523 21 22V20.0874C21 19.5665 20.474 19.2104 19.9904 19.4038C17.4522 20.4191 14.601 20.3005 12.1559 19.078L10.2127 18.1063C10.1421 18.0711 10.0712 18.0368 10 18.0036V17H11C13.2091 17 15 15.2091 15 13V11.5C15 10.6716 14.3284 10 13.5 10C12.6716 10 12 10.6716 12 11.5V13C12 13.5523 11.5523 14 11 14H10V7C10 5.89543 9.10457 5 8 5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 9C20.75 8.58579 20.4142 8.25 20 8.25C19.5858 8.25 19.25 8.58579 19.25 9V11C19.25 11.4142 19.5858 11.75 20 11.75C20.4142 11.75 20.75 11.4142 20.75 11V9Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9947 7.00531C17.2876 7.29821 17.2876 7.77308 16.9947 8.06597L15.5805 9.48019C15.2876 9.77308 14.8127 9.77308 14.5198 9.48019C14.2269 9.18729 14.2269 8.71242 14.5198 8.41953L15.934 7.00531C16.2269 6.71242 16.7018 6.71242 16.9947 7.00531Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.75C15.4142 4.75 15.75 4.41421 15.75 4C15.75 3.58579 15.4142 3.25 15 3.25H13C12.5858 3.25 12.25 3.58579 12.25 4C12.25 4.41421 12.5858 4.75 13 4.75H15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesert);
export default __webpack_public_path__ + "static/media/desert.f87fa02b96f3a1025a799c53d9fe3d86.svg";
export { ForwardRef as ReactComponent };